import { IconName } from "components/ui/Icon";

export const NAVIGATION: Array<{
  title: string;
  shortTitle?: string;
  icon: IconName;
  path: string;
  hideMobile?: boolean;
}> = [
  {
    title: "Home",
    icon: "house",
    path: "",
  },
  {
    title: "Users",
    icon: "userCircle",
    path: "users",
  },
  {
    title: "Repayment Schedule",
    shortTitle: "Repay Sch",
    icon: "calendar",
    path: "repayment-schedule",
  },
  {
    title: "Card Transactions",
    shortTitle: "Card Txns",
    icon: "creditCard",
    path: "card-transactions",
  },
  {
    title: "Waitlist",
    icon: "squareList",
    path: "waitlists",
    hideMobile: true,
  },
  {
    title: "Financial Health Survey",
    shortTitle: "FH Survey",
    icon: "stethoscope",
    path: "financial-health",
    hideMobile: true,
  },
  {
    title: "Experiments",
    icon: "microscope",
    path: "experiments",
    hideMobile: true,
  },
];
